import React, { useEffect, useState } from "react";
import "./accountsManagment.css";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import MobileNav from "../../components/mobileNav/MobileNav";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const AccountsManagment = () => {
  const [globalLoading, setGlobalLoading] = useState(false);
  const [usernameLoading, setUsernameLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [error, setError] = useState(null);
  const [usersInfo, setUsersInfo] = useState([]);
  const [oldUserName, setOldUserName] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showUsernamePopup, setShowUsernamePopup] = useState(false);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Fetch all users
  const GetTechnicianInfo = async () => {
    try {
      setGlobalLoading(true);
      const url =
        "https://api.generalhome.sa/api/Authenticate/GetAllUsers";
      const response = await axios.get(url);

      // Use the status returned by the API
      const usersWithStatus = response.data.map((user) => ({
        ...user,
        status: user.IsActive, // Use the actual status from the API
      }));

      setUsersInfo(usersWithStatus);
    } catch (err) {
      setError(err.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  const resetFormStates = () => {
    setOldUserName("");
    setNewUserName("");
    setOldPassword("");
    setNewPassword("");
    setError("");
  };

  // =============== Change username ============
  const changeUserName = async (e) => {
    e.preventDefault();

    try {
      // Validate inputs
      if (!oldUserName || !newUserName) {
        setError("يرجى ملء جميع الحقول المطلوبة.");
        return;
      }

      setUsernameLoading(true); // Set loading state for username change
      setError(""); // Clear any previous errors

      // Retrieve the token from localStorage
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No token found. Please log in again.");
      }

      // Make the API request
      const url =
        "https://api.generalhome.sa/api/Authenticate/changeusername";
      const response = await axios.post(
        url,
        {
          OldUsername: oldUserName,
          NewUsername: newUserName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Handle the response
      if (response.status === 200) {
        setShowUsernamePopup(false); // Close the popup after success
        GetTechnicianInfo(); // Refresh the user list
        setNewUserName("");
      } else {
        throw new Error(response.data.message || "فشل تغيير اسم المستخدم.");
      }
    } catch (err) {
      // Handle errors
      if (err.response?.status === 401) {
        // Token is invalid or expired
        localStorage.removeItem("token"); // Remove the invalid token
        window.location.href = "/login"; // Redirect to login page
      } else {
        setError(err.message || "حدث خطأ أثناء تغيير اسم المستخدم.");
      }
      console.error("Error:", err);
    } finally {
      setUsernameLoading(false); // Reset loading state for username change
    }
  };

  // ============== Change password ===============
  const changePassword = async (e) => {
    e.preventDefault();
    try {
      // Validate inputs
      if (!oldPassword || !newPassword) {
        setError("يرجى ملء جميع الحقول المطلوبة.");
        return;
      }

      // Password validation checks
      const unmetRequirements = [];

      if (newPassword.length < 8) {
        unmetRequirements.push(
          "• يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل"
        );
      }

      if (!/[A-Z]/.test(newPassword)) {
        unmetRequirements.push(
          "• يجب أن تحتوي على حرف كبير واحد على الأقل (A-Z)"
        );
      }

      if (!/[a-z]/.test(newPassword)) {
        unmetRequirements.push(
          "• يجب أن تحتوي على حرف صغير واحد على الأقل (a-z)"
        );
      }

      if (!/\d/.test(newPassword)) {
        unmetRequirements.push("• يجب أن تحتوي على رقم واحد على الأقل (0-9)");
      }

      if (!/[@$!%*?&]/.test(newPassword)) {
        unmetRequirements.push(
          "• يجب أن تحتوي على حرف خاص واحد على الأقل (@$!%*?&)"
        );
      }

      if (unmetRequirements.length > 0) {
        setError(
          "يرجى استيفاء المتطلبات التالية:\n" + unmetRequirements.join("\n")
        );
        return;
      }

      setPasswordLoading(true);
      setError("");

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No token found. Please log in again.");
      }

      const url =
        "https://api.generalhome.sa/api/Authenticate/changepassword";
      const response = await axios.post(
        url,
        {
          Username: selectedUser,
          CurrentPassword: oldPassword,
          NewPassword: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setShowPasswordPopup(false);
        GetTechnicianInfo();
        resetFormStates();

        Swal.fire({
          title: "تم!",
          text: "تم تغيير كلمة المرور بنجاح",
          icon: "success",
          confirmButtonColor: "#00b1ff",
        });
      } else {
        throw new Error(
          response.data.message ||
            response.data.Errors ||
            "فشل تغيير كلمة المرور."
        );
      }
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else {
        setError(err.message || "حدث خطأ أثناء تغيير كلمة المرور.");
      }
      console.error(err);
    } finally {
      setPasswordLoading(false);
    }
  };

  // ============== Toggle account status ===============
  const toggleAccountStatus = async (user) => {
    const result = await Swal.fire({
      title: user.status ? "تعطيل الحساب" : "تفعيل الحساب",
      text: user.status
        ? "هل أنت متأكد أنك تريد تعطيل هذا الحساب؟"
        : "هل أنت متأكد أنك تريد تفعيل هذا الحساب؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "نعم",
      cancelButtonText: "إلغاء",
      confirmButtonColor: "#00b1ff",
      cancelButtonColor: "#d33",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No token found. Please log in again.");
      }

      const url =
        "https://api.generalhome.sa/api/Authenticate/ActiveOrDeactiveUser";
      const response = await axios.post(
        url,
        {
          UserId: user.Id,
          IsActive: !user.status, // Toggle the status
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        // Update the user's status in the local state
        const updatedUsers = usersInfo.map((u) =>
          u.Id === user.Id ? { ...u, status: !u.status } : u
        );
        setUsersInfo(updatedUsers);

        // Show success message
        Swal.fire({
          title: "تم!",
          text: user.status
            ? "تم تعطيل الحساب بنجاح."
            : "تم تفعيل الحساب بنجاح.",
          icon: "success",
          confirmButtonColor: "#00b1ff",
        });
      } else {
        throw new Error(response.data.message || "فشل تغيير حالة الحساب.");
      }
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء تغيير حالة الحساب.");
      console.error("Error:", err);

      // Show error message
      Swal.fire({
        title: "خطأ!",
        text: err.message || "حدث خطأ أثناء تغيير حالة الحساب.",
        icon: "error",
        confirmButtonColor: "#00b1ff",
      });
    }
  };

  // Open username popup
  const openUsernamePopup = (user) => {
    setSelectedUser(user.UserName);
    setOldUserName(user.UserName);
    setShowUsernamePopup(true);
  };

  // Open password popup
  const openPasswordPopup = (user) => {
    setSelectedUser(user.UserName);
    setOldUserName(user.UserName);
    setShowPasswordPopup(true);
  };

  useEffect(() => {
    GetTechnicianInfo();
  }, []);

  return (
    <>
      <MobileNav />
      <section className="accountsManagment">
        {globalLoading ? (
          <div className="spinner-container">
            <ClipLoader
              className="loader"
              loading={globalLoading}
              size={100}
              aria-label="Loading Spinner"
              data-testid="loader"
              color="#00b1ff"
            />
          </div>
        ) : (
          <div className="accountsManagment-container container">
            <h2 className="mb-5">اداره حسابات مسئولين الصيانه:</h2>
            <div className="table-responsive-sm overflow-auto">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th scope="row">اسم المستخدم</th>
                    <th scope="row">تفعيل الحساب</th>
                    <th scope="row" className="text-center">
                      التحكم
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {usersInfo.map((item) => (
                    <tr key={item.Id}>
                      <td>{item.UserName}</td>
                      <td>
                        <div
                          className={`switch ${item.status ? "active" : ""}`}
                          onClick={() => toggleAccountStatus(item)}
                        >
                          <div className="slider"></div>
                        </div>
                      </td>
                      <td className="text-center d-flex justify-content-center buttons-box">
                        <button
                          type="button"
                          onClick={() => openUsernamePopup(item)}
                        >
                          تعديل اسم المستخدم
                        </button>
                        <button
                          type="button"
                          onClick={() => openPasswordPopup(item)}
                        >
                          تعديل كلمه المرور
                        </button>
                        <Link
                          to={`/dashboard/personalData/${item.Id}`}
                          type="button"
                        >
                          <button>الملف الشخصي</button>
                        </Link>
                        {item.Roles.includes("Technician") ? (
                          <Link
                            to={`/dashboard/techStatics/${item.Id}`}
                            type="button"
                          >
                            <button>احصائيات الفني</button>
                          </Link>
                        ) : (
                          <span className="no-stats-text">
                            لا توجد إحصائيات
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Username Change Popup */}
        {showUsernamePopup && (
          <div className="popup-overlay">
            <div className="popup">
              <h3>تعديل اسم المستخدم</h3>
              <form onSubmit={changeUserName}>
                <div className="input-group">
                  <label>اسم المستخدم الحالي:</label>
                  <input
                    type="text"
                    value={oldUserName}
                    onChange={(e) => setOldUserName(e.target.value)}
                    disabled
                  />
                </div>
                <div className="input-group">
                  <label>اسم المستخدم الجديد:</label>
                  <input
                    type="text"
                    value={newUserName}
                    onChange={(e) => setNewUserName(e.target.value)}
                    // required
                  />
                </div>
                {error && <p className="error">{error}</p>}
                <button type="submit" disabled={usernameLoading}>
                  {usernameLoading ? "جاري التحميل..." : "تغيير اسم المستخدم"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    resetFormStates();
                    setShowUsernamePopup(false);
                  }}
                >
                  إلغاء
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Password Change Popup */}
        {showPasswordPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <h3>تعديل كلمة المرور</h3>
              <form onSubmit={changePassword}>
                <div className="input-group">
                  <label>اسم المستخدم:</label>
                  <input
                    type="text"
                    value={oldUserName}
                    onChange={(e) => setOldUserName(e.target.value)}
                    disabled
                  />
                </div>
                <div className="input-group">
                  <label>كلمة المرور الحالية:</label>
                  <input
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>
                <div className="input-group">
                  <label>كلمة المرور الجديدة:</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setError("");
                    }}
                  />
                  {error && <p className="error">{error}</p>}
                  <div className="password-requirements">
                    <small>متطلبات كلمة المرور:</small>
                    <ul>
                      <li
                        className={
                          newPassword.length >= 8 ? "valid" : "invalid"
                        }
                      >
                        {newPassword.length >= 8 ? "✓ " : "✗ "}8 أحرف على الأقل
                      </li>
                      <li
                        className={
                          /[A-Z]/.test(newPassword) ? "valid" : "invalid"
                        }
                      >
                        {/[A-Z]/.test(newPassword) ? "✓ " : "✗ "}حرف كبير واحد
                        على الأقل (A-Z)
                      </li>
                      <li
                        className={
                          /[a-z]/.test(newPassword) ? "valid" : "invalid"
                        }
                      >
                        {/[a-z]/.test(newPassword) ? "✓ " : "✗ "}حرف صغير واحد
                        على الأقل (a-z)
                      </li>
                      <li
                        className={/\d/.test(newPassword) ? "valid" : "invalid"}
                      >
                        {/\d/.test(newPassword) ? "✓ " : "✗ "}رقم واحد على الأقل
                        (0-9)
                      </li>
                      <li
                        className={
                          /[@$!%*?&]/.test(newPassword) ? "valid" : "invalid"
                        }
                      >
                        {/[@$!%*?&]/.test(newPassword) ? "✓ " : "✗ "}حرف خاص
                        واحد على الأقل (@$!%*?&)
                      </li>
                    </ul>
                  </div>
                </div>
                <button type="submit" disabled={passwordLoading}>
                  {passwordLoading ? "جاري التحميل..." : "تغيير كلمة المرور"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    resetFormStates();
                    setShowPasswordPopup(false);
                  }}
                >
                  إلغاء
                </button>
              </form>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default AccountsManagment;
